import * as tslib_1 from "tslib";
import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
var RecommenderFormDialogComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {MatDialogRef<RecommenderFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    function RecommenderFormDialogComponent(matDialogRef, _data, _recommenderService, _formBuilder, _matSnackBar, _companyService, _translate, _translationLoader) {
        this.matDialogRef = matDialogRef;
        this._data = _data;
        this._recommenderService = _recommenderService;
        this._formBuilder = _formBuilder;
        this._matSnackBar = _matSnackBar;
        this._companyService = _companyService;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.lang = 'sr';
        this._unsubscribeAll = new Subject();
        // Set the defaults
        this.action = _data.action;
        this.dialogTitle = 'New recommendation';
        this.recommenderForm = this.createRecommendationForm();
        this.maxDate = moment();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    RecommenderFormDialogComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '25');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    Object.defineProperty(RecommenderFormDialogComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () { return this.recommenderForm.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    RecommenderFormDialogComponent.prototype.createRecommendationForm = function () {
        return this._formBuilder.group({
            first_name: [],
            last_name: [],
            email: [],
            phone_number: [],
            date_of_birth: []
        });
    };
    RecommenderFormDialogComponent.prototype.checkServerError = function (fieldName) {
        return this.recommenderForm.get(fieldName).errors ? this.recommenderForm.get(fieldName).errors.serverError ?
            this.recommenderForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    };
    RecommenderFormDialogComponent.prototype.createRecommendation = function (recommenderForm) {
        var _this = this;
        var data = recommenderForm.getRawValue();
        if (!data.date_of_birth) {
            data.date_of_birth = null;
        }
        else {
            if (moment.isMoment(data.date_of_birth)) {
                data.date_of_birth = data.date_of_birth.format('YYYY-MM-DD');
            }
        }
        this._recommenderService.createRecommendation(data, this.company.id, this.lang)
            .then(function (x) {
            _this.matDialogRef.close(['save', recommenderForm]);
            // Show the success message
            _this._matSnackBar.open(_this._translate.instant('Recommendation for') + ' ' +
                recommenderForm.getRawValue().first_name + ' ' + recommenderForm.getRawValue().last_name + _this._translate.instant(' created successfully.'), '', {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 2000
            });
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function (x) { }, function (err) {
            var e_1, _a;
            var validationErrors = err.error;
            try {
                for (var _b = tslib_1.__values(Object.keys(validationErrors)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    var formControl = _this.recommenderForm.get(key);
                    if (formControl) {
                        formControl.setErrors({
                            serverError: validationErrors[key]
                        });
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    RecommenderFormDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._companyService.getActiveCompany()
            .then(function (response) {
            _this.company = response;
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
            _this._recommenderService.getAllRequestTypes(_this.company.id)
                .then(function (response) {
                _this.requestTypes = response.data;
                console.log(_this.requestTypes);
            });
        }, function (err) {
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
    };
    RecommenderFormDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return RecommenderFormDialogComponent;
}());
export { RecommenderFormDialogComponent };
